/* global globalMethods:false */

(function() {
	/**
	 * Delayed loading of logos
	 */

	globalMethods.loadPartnerLogos = function(elements) {
		Array.prototype.forEach.call(elements, function(element) {
			var id = element.getAttribute('data-id');
			var request = new XMLHttpRequest();
			request.open('GET', '/lazy-content/partner-logos/' + id + '/index.html', true);

			request.onload = function() {
				if (this.status >= 200 && this.status < 400) {
					var content = this.response;
					element.innerHTML += content;
					element.classList.add('lazy-logos--loaded');
				}
			};

			request.send();
		});
	};

	const lazyLogosElements = document.querySelectorAll('.js-lazy-logos');
	globalMethods.loadPartnerLogos(lazyLogosElements);



	/**
	 * Items with applied crossfade-animation can be hidden to prevent loading images
	 * in invisible items in the row. This is workaround for revealing of hidden items
	 * in correct order.
	 */

	document.addEventListener('animationstart', function (e) {
		var match = e.animationName.match(/cf[1-9]-fade-in-out/);

		if (match) {
			e.target.classList.remove('hidden');
			var nextSibling = e.target.nextElementSibling;

			if (nextSibling) {
				nextSibling.classList.remove('hidden');
			}
		}
	});
})();
